
import { LucideIcon } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";

interface CoreFeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  features: string[];
}

export function CoreFeatureCard({ icon: Icon, title, description, features }: CoreFeatureCardProps) {
  return (
    <Card className="hover-scale">
      <CardHeader className="pb-2">
        <div className="bg-primary/10 p-3 rounded-lg w-fit mb-3">
          <Icon className="h-6 w-6 text-primary" />
        </div>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary flex-shrink-0" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
